import React from 'react';
import { getFitVerdictChip } from '../../utils/formatters';

export default function VerdictBadge({ verdict, className = '' }) {
  const { label, chipClass } = getFitVerdictChip(verdict);
  return (
    <span className={`chip ${chipClass} ${className}`}>
      {label}
    </span>
  );
}
